import { render, staticRenderFns } from "./DetailHasilUjianType.vue?vue&type=template&id=3cf3e996&scoped=true"
import script from "./DetailHasilUjianType.vue?vue&type=script&lang=js"
export * from "./DetailHasilUjianType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf3e996",
  null
  
)

export default component.exports